import * as React from 'react';
import { useHistory } from 'react-router-dom';

import Button from 'global_elements/Button';
import FlexContainer from 'global_elements/Layouts/FlexContainer';
import Paragraph from 'global_elements/Text/Paragraph';
import { ButtonVariant } from 'global_elements/Button/variants';
import { DisplayVariant, JustifyVariant, AlignVariant } from 'global_elements/Layouts/FlexContainer/variants';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import { ReportCardProps } from 'types/cardProps';
import { AllRoutes } from 'constants/routes';
import { ReactComponent as RightArrow } from 'icons/mho-right-arrow-white-icon.svg';

import './styles.scss';

const ReportCard = (props: ReportCardProps): React.JSX.Element => {
  const history = useHistory();
  const programFilterQuery = props.programFilter ? `&pf=${props.programFilter}` : '';
  const programFilterIDQuery = props.programFilterID ? `&pfid=${props.programFilterID}` : '';
  // const { user } = React.useContext(UserContext);

  return (
    <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.START} align={AlignVariant.END} extraClasses="report-card-wrapper">
      <FlexContainer display={DisplayVariant.FLEX_ROW} justify={JustifyVariant.CENTER} align={AlignVariant.CENTER} extraClasses="report-card-row-container">
        <div className="blue-column" />
        <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.SPACE_BETWEEN} align={AlignVariant.START} extraClasses="report-card-content">
          <FlexContainer display={DisplayVariant.FLEX_ROW} justify={JustifyVariant.START} align={AlignVariant.START} extraClasses="report-card-content-header">
            <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.START} align={AlignVariant.START} extraClasses="report-card-content-header-text">
              <Paragraph text={props.title} fontColor={FontColors.SECONDARY} fontSize={FontSizes.LARGE} bold />
              <Paragraph text={props.reportDesc} fontColor={FontColors.SECONDARY} fontSize={FontSizes.SMALL} extraClasses="report-card-content-header-text-desc" />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>

        <FlexContainer display={DisplayVariant.FLEX_ROW} justify={JustifyVariant.END} align={AlignVariant.START} extraClasses="report-card-bottom">
          <FlexContainer display={DisplayVariant.FLEX_ROW} justify={JustifyVariant.SPACE_BETWEEN} align={AlignVariant.START} extraClasses="report-card-cta">
            <Button
              variant={ButtonVariant.PRIMARY}
              onClick={() => {
                history.push(
                  `${AllRoutes.VIEW_REPORT}?reportID=${props.reportIDHash}&cm=${props.isCoreMeasures ? 1 : 0}&reportname=${encodeURI(props.title)}${programFilterQuery}${programFilterIDQuery}`,
                );
              }}
            >
              <FlexContainer display={DisplayVariant.FLEX_ROW} justify={JustifyVariant.START} align={AlignVariant.CENTER} extraClasses="report-card-cta-button-contents">
                <Paragraph text="View Report" fontColor={FontColors.WHITE} fontSize={FontSizes.REGULAR} extraClasses="report-card-cta-button-contents-text" />
                <RightArrow className="report-card-cta-button-contents-arrow" aria-hidden="true" focusable="false" />
              </FlexContainer>
            </Button>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default React.memo(ReportCard);
